import download from 'downloadjs';

export class VendorService {

    async downloadPaidVendorsCSV() {
        download(`https://${process.env.REACT_APP_BLOB_STORAGE_URL}/vendors/paid_vendors.csv`);
    }

    async downloadApprovedVendorsCSV() {
        download(`https://${process.env.REACT_APP_BLOB_STORAGE_URL}/vendors/approved_vendors.csv`);
    }

    // this method will get vendor category drop down data
    async getVendorCategoryData() {
        const sbDataUrl = `https://${process.env.REACT_APP_BLOB_STORAGE_URL}/vendors/vendor_categories.json`;

        return await fetch(sbDataUrl).then(response => {
            return response.json();
        })
            .catch(err => console.log(err.message));
    }

    async getVendorLocationData() {
        const sbDataUrl = `https://${process.env.REACT_APP_BLOB_STORAGE_URL}/vendors/vendor_locations.json`;

        return await fetch(sbDataUrl).then(response => {
            return response.json();
        })
            .catch(err => console.log(err.message));
    }

    //this method will get all paid vendor data (Vendor Number and Vendor Name only)
    async getPaidVendorsData() {

        const sbDataUrl = `https://${process.env.REACT_APP_BLOB_STORAGE_URL}/vendors/paid_vendors.json`;

        return await fetch(sbDataUrl).then(response => {
            return response.json();
        })
        .catch(err => console.log(err.message));
    }

    // this method will get all approved vendor data (Vendor Number and Vendor Name only)
    async getApprovedVendorsData() {

        const sbDataUrl = `https://${process.env.REACT_APP_BLOB_STORAGE_URL}/vendors/approved_vendors.json`;

        return await fetch(sbDataUrl).then(response => {
                return response.json();
            })
            .catch(err => console.log(err.message));
    }

    //this method will get all vendor check data based on the getPaidVendorsData() method
    async getVendorCheckData(vendorNumber) {
        const sbDataUrl = `https://${process.env.REACT_APP_BLOB_STORAGE_URL}/vendors/${vendorNumber}.json`;

        return await fetch(sbDataUrl).then(response => {
            if (response.status === 404) {
                throw new Error(`No data found for vendor ${vendorNumber}.`);
            }
            return response.json();
        })
          .catch(err => console.log(err.message));
    }
}